var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      attrs: {
        name: "authorization-dialog",
        title: _vm.title,
        autofocus: _vm.$refs.password
      },
      on: { hide: _vm.cancel },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c("template", { slot: "content" }, [
        _c("p", [_vm._v(_vm._s(_vm.message))]),
        _c(
          "form",
          {
            attrs: { id: "authorization-dialog" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.handleAuthorize($event)
              }
            }
          },
          [
            _c(
              "q-field",
              {
                attrs: {
                  error: _vm.errors.has("auth-dialog__password"),
                  "error-label": _vm.errors.first("auth-dialog__password")
                }
              },
              [
                _c("q-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required",
                      expression: "'required'",
                      modifiers: { disable: true }
                    }
                  ],
                  ref: "password",
                  attrs: {
                    type: "password",
                    "float-label": _vm.$t("password"),
                    name: "auth-dialog__password",
                    "data-vv-as": _vm.$t("password"),
                    autocomplete: "current-password",
                    required: ""
                  },
                  on: {
                    keydown: function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleAuthorize($event)
                    }
                  },
                  model: {
                    value: _vm.password,
                    callback: function($$v) {
                      _vm.password = $$v
                    },
                    expression: "password"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "q-btn",
            {
              attrs: { color: "positive" },
              on: { click: _vm.handleAuthorize }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("authorize")) + "\n    ")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }